/* eslint-disable react-hooks/exhaustive-deps*/
import React, { useEffect, useRef, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import * as HERBUI from "react-bootstrap";
import { ErrorMessage, Field, Formik, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import Swal from "sweetalert2";
import Header from "./Header";
import Footer from "./Footer";
import { CommonAjaxGetRequestWithOutParamsWithOutAuthorization, CommonAjaxPostLoginRequestUpdated, CommonAjaxPostRequest } from "../Api/CommonAjaxUtils";
import { LOGIN_API_BASE_URL, LOGIN_API_UPDATED, LOGIN_PAGE_URL } from "../Api/APIURLS";
import Sweetalert, { allowNumbersOnly, formatCountdown, getClockSkew, popover, preventCopyPaste, startOtpTimer } from "../components/Functions";
import { useDispatch } from "react-redux";
// import { useLocation } from "react-router-dom";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';


import { useHistory, useLocation } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
export default function ForgotPassword() {
    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const otpTimerCleanupRef = useRef(null);


    const [remainingTime, setRemainingTime] = useState(0);
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [showTimer, setShowTimer] = useState(false);
    const [otp, setOtp] = useState(["", "", "", "", "", ""]);
    const inputRefs = useRef([]);

    const FORM_STEP = {
        GET_OTP: "GET_OTP",
        VERIFY_OTP: "VERIFY_OTP",
        SET_PASSWORD: "SET_PASSWORD"
    };
    const FORM_STEP_LABELS = {
        GET_OTP: "Get OTP",
        VERIFY_OTP: "Verify OTP",
        SET_PASSWORD: "Set Password"
    };


    const [step, setStep] = useState(FORM_STEP.GET_OTP);

    useEffect(() => {
        return () => {
            if (otpTimerCleanupRef.current) {
                otpTimerCleanupRef.current();
            }
        };
    }, []);

    const startTimer = (expiryTime, clockSkewMs) => {
        // Stop previous timer
        if (otpTimerCleanupRef.current) {
            otpTimerCleanupRef.current();
            otpTimerCleanupRef.current = null;
        }

        // Start new timer
        otpTimerCleanupRef.current = startOtpTimer(
            expiryTime,
            setRemainingTime,
            clockSkewMs
        );
    };

    const handleChange = (value, index) => {
        // Allow only one digit
        if (!/^\d?$/.test(value)) {
            return;
        }

        const newOtp = [...otp];
        newOtp[index] = value;

        setOtp(newOtp);

        // Store complete OTP in Formik
        formik.setFieldValue("enteredOtp", newOtp.join(""));
        formik.setFieldTouched("enteredOtp", true, false);

        // Move to next input
        if (value && index < otp.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e, index) => {
        // Backspace
        if (e.key === "Backspace") {
            if (otp[index]) {
                // Clear current box
                const newOtp = [...otp];
                newOtp[index] = "";

                setOtp(newOtp);
                formik.setFieldValue("enteredOtp", newOtp.join(""));
            } else if (index > 0) {
                // Move to previous box and clear it
                const newOtp = [...otp];
                newOtp[index - 1] = "";

                setOtp(newOtp);
                formik.setFieldValue("enteredOtp", newOtp.join(""));

                inputRefs.current[index - 1]?.focus();
            }
        }

        // Move to previous box
        if (e.key === "ArrowLeft" && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }

        // Move to next box
        if (e.key === "ArrowRight" && index < otp.length - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };


    useEffect(() => {
        if (remainingTime === 0) {
            setShowTimer(false);
            setErrorMessage("");
        }
    }, [remainingTime])

    const forgotPasswordInitialValues = {
        cfmsId: '',
        name: '',
        mobileNo: '',
        email: '',
        enteredOtp: '',
        secureKey: '',
        lookupToken: '',
        challengeId: '', challengeExpiresAt: '', newPassword: '', confirmPassword: '',
        resetToken: '', showGetOTPButton: false
    }

    const getValidationSchema = () => {
        switch (step) {
            case FORM_STEP.GET_OTP:
                return Yup.object().shape({
                    cfmsId: Yup.string()
                        .required('CFMS ID is required')
                        .matches(
                            /^\d+$/,
                            'Only numbers are allowed'
                        )
                });
            case FORM_STEP.VERIFY_OTP:
                return Yup.object().shape({
                    enteredOtp: Yup.string()
                        .required('OTP is required')
                        .matches(
                            /^\d{6}$/,
                            'OTP must be exactly 6 digits'
                        )
                });
            case FORM_STEP.SET_PASSWORD:
                return Yup.object().shape({
                    newPassword: Yup.string().nullable()
                        .required('New password is required'),
                    confirmPassword: Yup.string()
                        .required('Confirm password is required')
                        .oneOf(
                            [Yup.ref('newPassword')],
                            'New Password and Confirm Password not matched'
                        )
                });
            default:
                return Yup.object().shape({});
        }
    };

    const formik = useFormik({
        initialValues: forgotPasswordInitialValues,
        validationSchema: getValidationSchema(),
        onSubmit: (values) => {
            SaveUpdateMobileNumber(values);
        }
    })

    const showOTPButton = formik.values.cfmsId !== '' &&
        formik.values.mobileNo !== 0 && formik.values.mobileNo !== '' &&
        formik.values.email !== 0 && formik.values.email !== ''


    const SaveUpdateMobileNumber = (values) => {
        localStorage.removeItem('passwordExpiry')
        let params =
            { "lookupToken": formik.values?.lookupToken }
        if (step === FORM_STEP.GET_OTP) {
            CommonAjaxPostLoginRequestUpdated(LOGIN_API_UPDATED + 'auth/forgot-password/send-otp', params, dispatch).then(res => {
                if (res) {
                    if (res?.status === 200) {
                        handleSuccessResponse(res);
                        setStep(FORM_STEP.VERIFY_OTP);
                    }
                    else {
                        handleFailureResponse(res);
                    }
                }
            })
        }
        else if (step === FORM_STEP.VERIFY_OTP) {
            params = { "challengeId": formik.values.challengeId, "otp": formik.values.enteredOtp }
            CommonAjaxPostLoginRequestUpdated(LOGIN_API_UPDATED + 'auth/forgot-password/verify-otp', params, dispatch).then(res => {
                if (res) {
                    if (res.status === 200) {
                        setErrorMessage("");
                        setSuccessMsg(res?.data?.message);
                        formik.setFieldValue('resetToken', res?.data?.resetToken);
                        setStep(FORM_STEP.SET_PASSWORD);
                        const clockSkewMs = getClockSkew(res?.headers);
                        startTimer(
                            res?.data?.resetTokenExpiresAt,
                            clockSkewMs
                        );
                        // startOtpTimer(res?.data?.resetTokenExpiresAt, setRemainingTime, clockSkewMs);
                        // startOtpTimer(response.challengeExpiresAt, setRemainingTime);
                        setShowTimer(true);
                    }
                    else {
                        dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
                        if (res?.status === 408) {
                            Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                                if (isConfirm.value) {
                                    window.location.href = '/forgotPassword';
                                }
                            })
                            return;
                        }
                        if (res?.status === 410) {
                            Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                                if (isConfirm.value) {
                                    window.location.href = '/forgotPassword';
                                }
                            })
                            return;
                        }
                        const clockSkewMs = getClockSkew(res?.headers);
                        startTimer(
                            res?.data?.tokenExpiresAt,
                            clockSkewMs
                        );
                        // startOtpTimer(res?.data?.resetTokenExpiresAt, setRemainingTime, clockSkewMs);
                        // startOtpTimer(response.challengeExpiresAt, setRemainingTime);
                        setShowTimer(true);
                        setSuccessMsg("");
                        setErrorMessage(res?.data?.errorMessage);

                    }
                }
            })
        }
        else if (step === FORM_STEP.SET_PASSWORD) {
            let params = {
                "resetToken": formik.values.resetToken,
                "cfmsId": formik.values.cfmsId,
                "newPassword": formik.values.newPassword,
                "confirmPassword": formik.values.confirmPassword
            }

            CommonAjaxPostLoginRequestUpdated(LOGIN_API_UPDATED + 'auth/forgot-password/set-password', params, dispatch).then(res => {
                if (res) {
                    if (res.status === 200) {
                        Sweetalert(res?.data?.message, 'success').then(function (isConfirm) {
                            if (isConfirm.value) {
                                history.push("/loginPageUpdated");
                            }
                        })
                    }
                    else {
                        dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
                        setSuccessMsg("");
                        setErrorMessage(res?.data?.errorMessage);
                        if (res?.status === 408) {
                            Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                                if (isConfirm.value) {
                                    window.location.href = '/forgotPassword';
                                }
                            })
                            return;
                        }
                        if (res?.status === 410) {
                            Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                                if (isConfirm.value) {
                                    window.location.href = '/forgotPassword';
                                }
                            })
                            return;
                        }
                        if (res?.status === 429) {
                            Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                                if (isConfirm.value) {
                                    window.location.href = '/forgotPassword';
                                }
                            })
                            return;
                        }
                        const clockSkewMs = getClockSkew(res?.headers);
                        // startOtpTimer(res?.data?.tokenExpiresAt, setRemainingTime, clockSkewMs);
                        startTimer(
                            res?.data?.tokenExpiresAt,
                            clockSkewMs
                        );
                        setShowTimer(true);
                        // startOtpTimer(res?.data?.tokenExpiresAt, setRemainingTime);

                    }
                }
            })
        }
    }
    const regex = /^\d+$/;

    const getDetails = (cfmsIdValue) => {

        const cfmsId = cfmsIdValue?.trim();

        formik.setFieldError("cfmsId", "");
        if (!cfmsId) {
            formik.setFieldTouched("cfmsId", true);
            formik.setFieldError("cfmsId", "CFMS ID is required");
            return;
        }

        if (!regex.test(cfmsId)) {
            formik.setFieldTouched("cfmsId", true);
            formik.setFieldError("cfmsId", "Only Numbers are allowed");
            return;
        }
        CommonAjaxGetRequestWithOutParamsWithOutAuthorization(
            `${LOGIN_API_UPDATED}auth/forgot-password/user-details?cfmsId=${encodeURIComponent(cfmsId)}`,
            dispatch)
            .then((res) => {
                if (res) {
                    // formik.setFieldValue("showGetOTPButton", true);
                    formik.setValues({
                        ...formik.values,
                        cfmsId: cfmsId,
                        email: res?.email || 0,
                        mobileNo: res?.mobileNo || 0,
                        name: res?.name || "",
                        lookupToken: res?.lookupToken || "",
                        showGetOTPButton: true
                    }, true);
                } else {
                    // formik.setFieldValue("showGetOTPButton", false);
                    formik.setValues({
                        ...formik.values,
                        cfmsId: cfmsId,
                        email: 0,
                        mobileNo: 0,
                        name: "",
                        lookupToken: "",
                        showGetOTPButton: false
                    }, false);

                    // formik.setFieldTouched("cfmsId", true);
                    // formik.setFieldError(
                    //     "cfmsId",
                    //     "CFMS ID details not found"
                    // );
                }
            })
            .catch((error) => {
                console.error("CFMS details error:", error);
                // formik.setFieldTouched("cfmsId", true);
                // formik.setFieldError(
                //     "cfmsId",
                //     error?.response?.data?.message ||
                //     "Internal Server Error"
                // );
            });
    };

    const handleSuccessResponse = (res) => {
        setErrorMessage("");
        let responseData = res?.data;
        setSuccessMsg(responseData?.message);
        formik.setFieldValue('challengeId', responseData?.challengeId);
        formik.setFieldValue('challengeExpiresAt', responseData?.challengeExpiresAt);
        const clockSkewMs = getClockSkew(res?.headers);
        // startOtpTimer(responseData.challengeExpiresAt, setRemainingTime, clockSkewMs);
        startTimer(
            responseData.challengeExpiresAt,
            clockSkewMs
        );
        // startOtpTimer(response.challengeExpiresAt, setRemainingTime);
        setShowTimer(true);
    }

    const handleFailureResponse = (res) => {
        dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
        let respData = res?.data;
        setErrorMessage(respData?.errorMessage);
        setSuccessMsg("");
        if (respData?.status === 408) {
            dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
            Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                if (isConfirm.value) {
                    window.location.href = '/forgotPassword';
                    // history.push('/loginPageUpdated');
                }
            })
            return;
            // setRemainingTime(0);
        }
        if (res?.status === 410) {
            dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
            Sweetalert(res?.data?.errorMessage, 'warning').then(function (isConfirm) {
                if (isConfirm.value) {
                    window.location.href = '/forgotPassword';
                    // history.push('/loginPageUpdated');
                }
            })
            return;
        }
        const clockSkewMs = getClockSkew(res?.headers);
        // startOtpTimer(responseData.challengeExpiresAt, setRemainingTime, clockSkewMs);
        startTimer(
            res?.data?.tokenExpiresAt,
            clockSkewMs
        );
        setShowTimer(true);
        // Swal.fire({ text: res?.data?.errorMessage, icon: 'warning' });

    }

    const cfmsIdOnChange = (e) => {
        formik.setFieldValue('cfmsId', e.target.value);
        formik.setFieldValue("showGetOTPButton", false);
        // if (e.target.value !== "") {
        //     if (regex.test(e.target.value)) {
        //         formik.setFieldValue('cfmsId', e.target.value);
        //     }
        //     else {
        //         Swal.fire({ text: "Only Numbers are allowed", icon: 'warning', confirmButtonColor: '#3085d6', });
        //     }
        // }
        // else {
        //     formik.setFieldValue('cfmsId', e.target.value);
        // }
    }



    const formattedTime = formatCountdown(remainingTime);


    const toggleConfirmPassword = () => {
        setShowConfirmPassword(prev => !prev)
    }
    const toggleNewPassword = () => {
        setShowNewPassword(prev => !prev)
    }





    return (
        <>   <Header />
            <div className="main_section"> </div>

            <HERBUI.Container style={{ marginTop: "80px" }}>
                <HERBUI.Row>
                    <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing">
                        <div className="inner-herbpage-service-title1">
                            <h1> Forgot Password</h1>
                        </div>
                    </HERBUI.Col>
                </HERBUI.Row>
            </HERBUI.Container>
            <HERBUI.Container className=" bg-white forgotps-all">
                <FormikProvider value={formik}>
                    <form onSubmit={formik.handleSubmit}>
                        <HERBUI.Row className="pt-5" >
                            <HERBUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                &nbsp;
                            </HERBUI.Col>
                            <HERBUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                                <div className="empDiv">
                                    <HERBUI.Row>
                                        {
                                            (step === FORM_STEP.GET_OTP || step === FORM_STEP.VERIFY_OTP) &&
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                <span className="text-success">Note: Here OTP Sents to you registered mobile Number</span>
                                            </HERBUI.Col>
                                        }
                                        <br /><br />
                                        <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                            <HERBUI.InputGroup className="mb-4p5">
                                                <span className="label-text-style"><b>Cfms Id:</b><span className="text-danger">*</span></span>
                                                <Field type="text" placeholder="Enter Cfms Id" name="cfmsId" onKeyPress={allowNumbersOnly}
                                                    disabled={step !== FORM_STEP.GET_OTP} autoComplete="off"
                                                    maxLength="10" onBlur={(e) => getDetails(e.target.value)} value={formik.values?.cfmsId} onChange={cfmsIdOnChange}
                                                    className={(formik.touched.cfmsId && formik.errors.cfmsId) ? 'form-control is-invalid' : 'form-control'}
                                                    onCopy={preventCopyPaste} onPaste={preventCopyPaste} onCut={preventCopyPaste} onDrop={preventCopyPaste} />
                                                <ErrorMessage name="cfmsId" className="text-error" component={'div'} />
                                            </HERBUI.InputGroup>
                                        </HERBUI.Col>
                                        {
                                            (step === FORM_STEP.GET_OTP || step === FORM_STEP.VERIFY_OTP) &&
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                <HERBUI.InputGroup className="mb-4p5">
                                                    <span className="label-text-style"><b>Employee Name:</b></span>
                                                    <Field type="text" placeholder="Enter Name" name="name"
                                                        value={formik.values?.name} disabled={true}
                                                        className={'form-control'} />
                                                </HERBUI.InputGroup>
                                            </HERBUI.Col>
                                        }

                                        <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                            <HERBUI.InputGroup className="mb-4p5">
                                                <span className="label-text-style"><b>Mobile No:</b></span>
                                                <Field type="text" placeholder="Enter Mobile No" name="mobileNo"
                                                    value={formik.values?.mobileNo}
                                                    maxLength="10" disabled={true}
                                                    className={'form-control'} />
                                            </HERBUI.InputGroup>
                                        </HERBUI.Col>
                                        {
                                            (step === FORM_STEP.GET_OTP || step === FORM_STEP.VERIFY_OTP) &&
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                <HERBUI.InputGroup className="mb-4p5">
                                                    <span className="label-text-style"><b>Email Id:</b></span>
                                                    <Field type="text" placeholder="Email Id" name="email"
                                                        value={formik.values?.email}
                                                        // maxLength="50"
                                                        disabled={true}
                                                        className={'form-control'} />
                                                </HERBUI.InputGroup>
                                            </HERBUI.Col>
                                        }

                                        {step === FORM_STEP.VERIFY_OTP &&
                                            <>
                                                {/* <HERBUI.InputGroup className="">
                                                <span className="label-text-style"><b>OTP:</b></span>
                                                <Field type="text" placeholder="Enter OTP" name="enteredOtp" id="enteredOtp" maxLength="6" onChange={formik.handleChange}
                                                    onKeyPress={allowNumbersOnly} //value={document.getElementById("enteredOtp").value} 
                                                    className={(formik.touched.enteredOtp && formik.errors.enteredOtp) ? 'form-control is-invalid' : 'form-control'} />
                                                <ErrorMessage name="enteredOtp" className="text-error" component={'div'} />
                                            </HERBUI.InputGroup> */}
                                                <HERBUI.InputGroup className="mb-1">
                                                    <span className="label-text-style"  ><span className="mandatory" >*</span>Enter the OTP : </span>
                                                    <div className="herb-otp mt-1">
                                                        {otp.map((digit, index) => (
                                                            <input style={{ width: '35px' }}
                                                                key={index}
                                                                type="text"
                                                                maxLength={1}
                                                                value={digit}
                                                                ref={(el) => (inputRefs.current[index] = el)}
                                                                onChange={(e) => handleChange(e.target.value, index)}
                                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                            />
                                                        ))}
                                                    </div>
                                                    <ErrorMessage className="text-error" name="enteredOtp" component="div" />
                                                </HERBUI.InputGroup>
                                            </>
                                        }

                                        {
                                            step === FORM_STEP.SET_PASSWORD &&
                                            <>
                                                <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                    <OverlayTrigger trigger="hover" placement="right" overlay={popover}>
                                                        <HERBUI.InputGroup className="mb-4p5">
                                                            <span className="label-text-style"><b>Enter New Password:</b></span>
                                                            <Field type={showNewPassword ? "text" : "password"} placeholder="Enter New Password" name="newPassword"
                                                                value={formik.values?.newPassword} autoComplete="off"
                                                                maxLength="50" className={'form-control'} />
                                                            <HERBUI.InputGroup.Text id="basic-addon2 " className="basic-addon2">
                                                                {!showNewPassword ? <FaEyeSlash onClick={toggleNewPassword} /> : <FaEye onClick={toggleNewPassword} />}
                                                            </HERBUI.InputGroup.Text>
                                                        </HERBUI.InputGroup>
                                                    </OverlayTrigger>
                                                </HERBUI.Col>
                                                <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                    <OverlayTrigger trigger="hover" placement="right" overlay={popover}>
                                                        <HERBUI.InputGroup className="mb-4p5">
                                                            <span className="label-text-style"><b>Confirm New Password:</b></span>
                                                            <Field type={showConfirmPassword ? "text" : "password"} placeholder="Confirm New Password" name="confirmPassword"
                                                                value={formik.values?.confirmPassword} autoComplete="off"
                                                                maxLength="50" className={'form-control'} />
                                                            <HERBUI.InputGroup.Text id="basic-addon2 " className="basic-addon2">
                                                                {!showConfirmPassword ? <FaEyeSlash onClick={toggleConfirmPassword} /> : <FaEye onClick={toggleConfirmPassword} />}
                                                            </HERBUI.InputGroup.Text>
                                                            <ErrorMessage name="confirmPassword" className="text-error" component={'div'} />
                                                        </HERBUI.InputGroup>
                                                    </OverlayTrigger>
                                                </HERBUI.Col>
                                            </>
                                        }
                                    </HERBUI.Row>
                                    {
                                        (step === FORM_STEP.VERIFY_OTP || step === FORM_STEP.SET_PASSWORD) &&
                                        <>
                                            <span className="text-success d-block mt-1">
                                                {successMsg}
                                            </span><br />
                                            {
                                                (step === FORM_STEP.VERIFY_OTP || step === FORM_STEP.SET_PASSWORD) && showTimer &&
                                                <small className="text-danger fw-semibold d-block">

                                                    <> your {step === FORM_STEP.VERIFY_OTP ? ' OTP' : 'Session'} is expires in {formatCountdown(remainingTime)} </>
                                                    {/* {step === FORM_STEP.SET_PASSWORD &&
                                                        <> your Session is expires in {formatCountdown(remainingTime)} </>} */}
                                                </small>
                                            }
                                            {remainingTime === 0 && (
                                                <small className="text-danger">
                                                    OTP has expired
                                                </small>
                                            )}


                                        </>
                                    }
                                    {
                                        errorMessage &&
                                        <div>
                                            <span className="text-danger">
                                                {errorMessage}
                                            </span>
                                        </div>
                                    }

                                    <Field type="hidden" value="cfmsid" />
                                    <>
                                        <HERBUI.Row className=" mb-3">
                                            <HERBUI.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8}>
                                                &nbsp;
                                            </HERBUI.Col>
                                            {
                                                formik.values.mobileNo !== 0 &&
                                                <HERBUI.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                                    <div className="d-grid gap-2">
                                                        <button type="submit" className="btn btn-success" disabled={!formik.values.showGetOTPButton}>{FORM_STEP_LABELS[step]}</button>
                                                    </div>
                                                </HERBUI.Col>
                                            }

                                            {formik.values.cfmsId !== '' && (formik.values.mobileNo === 0) &&
                                                <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                                    <span className="text-error">
                                                        Please Update
                                                        {formik.values.mobileNo === 0 && " Mobile Number"}
                                                        {/* {formik.values.mobileNo === 0 &&
                                                            formik.values.email === 0 &&
                                                            " & "}
                                                        {formik.values.email === 0 && " Email Id"} */}
                                                    </span>
                                                </HERBUI.Col>
                                            }
                                        </HERBUI.Row>
                                    </>
                                </div>
                            </HERBUI.Col>
                            <HERBUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                &nbsp;
                            </HERBUI.Col>
                        </HERBUI.Row>
                    </form>
                </FormikProvider>
            </HERBUI.Container>
            <Footer />
        </>
    )
}